import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('div',[_c(VList,_vm._l((_vm.items),function(item){return _c(VListItem,{key:item.id,on:{"click":function($event){return _vm.onClick(item)}}},[_c(VListItemContent,[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }